module.exports = __webpack_public_path__ + "static/media/KHOF05.442ac28b.jpg";